<template>
  <!--
      圖片預覽區
      TODO: 拆成組件
      TODO: 路由拆分
    -->
  <section
    class="lightbox"
    v-show="isPhotoExpanded"
    v-scroll-lock="isPhotoExpanded"
  >
    <button
      class="lightbox__close"
      @click="closeFullPhoto"
      @keypress="closeFullPhoto"
      title="關閉照片預覽"
    >
      <span class="v-hidden">關閉照片預覽</span>
    </button>

    <!-- 圖片顯示區 -->
    <div class="lightbox__photo-container">
      <!-- 載入中 -->
      <LoadingIcon v-show="!isCurrentPhotoLoaded" />
      <!-- 圖片：預設是直的照片，加上「--horizontal」才是橫向的樣式 -->
      <img
        :src="currentPhoto.image_url"
        :alt="currentPhoto.description ? currentPhoto.description : ''"
        :title="currentPhoto.description"
        :class="[
          'lightbox__image',
          {
            'lightbox__image--horizontal': isHorizontal,
            'lightbox__image--opened': isCurrentPhotoLoaded,
          },
        ]"
        ref="lightboxExpandImage"
      />
      <noscript>
        <img
          :src="currentPhoto.image_url"
          :alt="currentPhoto.description ? currentPhoto.description : ''"
          :title="currentPhoto.description"
          :class="[
            'lightbox__image',
            { 'lightbox__image--horizontal': isHorizontal },
          ]"
          style="opacity: 1;"
        />
      </noscript>
    </div>

    <!-- 操作功能區 -->
    <div class="lightbox__actions">
      <!-- 因應需求關閉下載功能 -->
      <!-- <button>
          <img :src="require('@/assets/images/lightbox/download-photo.svg')" alt="下載此張照片" />
        </button> -->
      <button
        @click="closeFullPhoto"
        @keypress="closeFullPhoto"
        title="關閉照片預覽"
      >
        <img
          :src="require('@/assets/images/lightbox/close-photo.svg')"
          alt="關閉照片預覽"
        />
      </button>
    </div>
  </section>
</template>

<script>
import LoadingIcon from '@/components/LoadingIcon';

export default {
  name: 'Lightbox',
  props: {
    isPhotoExpanded: {
      type: Boolean,
      default: false,
    },
    currentPhoto: {
      type: Object,
      default: () => {},
    },
    isCurrentPhotoLoaded: {
      type: [Boolean, Object],
      default: null,
    },
  },
  data() {
    return {
      isHorizontal: null,
    };
  },
  computed: {
    currentPhotoDescription() {
      if (this.isPhotoExpanded) {
        return (
          this.currentPhoto.description ||
          '很抱歉！尚未建立關於此張照片的描述。'
        );
      } else {
        return '尚未開啟任何廟宇照片';
      }
    },
  },
  mounted() {
    // 圖片載入完成後才顯示，並隱藏動畫
    this.$refs.lightboxExpandImage.addEventListener('load', () => {
      this.$emit('update:currentPhotoLoaded', true);

      // 檢查照片方向
      this.getPhotoDirection(this.$refs.lightboxExpandImage);
    });

    window.addEventListener('keyup', this.handleKeyupByEscape);
  },
  unmounted() {
    window.removeEventListener('keyup', this.handleKeyupByEscape);
  },
  methods: {
    handleKeyupByEscape(event) {
      if (event.code === 'Escape') {
        this.closeFullPhoto();
      }
    },
    closeFullPhoto() {
      this.$emit('update:currentPhotoLoaded', null); // 關閉動畫的控制項
      this.$emit('update:photoExpanded', false);
      this.$emit('update:currentPhoto', {
        image_url: null,
        description: null,
      });

      this.isHorizontal = null;
    },
    // 定義照片是橫向還是直向
    getPhotoDirection(imgElement) {
      this.isHorizontal =
        imgElement.width / imgElement.height > 1 ? true : false;
    },
  },
  components: {
    LoadingIcon,
  },
};
</script>

<style lang="scss" scoped>
.lightbox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: getLayerIndex(light-box);

  button {
    @include button-theme(fake);
    cursor: pointer;
  }

  &__close {
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.8) !important;
    width: 100%;
    height: 100%;
  }

  &__photo-container {
    position: relative;
  }

  &__image {
    opacity: 0;
    transition: opacity ease-in 600ms;
    margin: auto;
    display: block;
    object-fit: contain;
    padding: 0 20px;

    // 直的方向
    max-height: 80vh;

    &--opened {
      opacity: 1;
    }

    &--horizontal {
      // 橫的方向
      max-height: 75vh;
    }
  }

  &__actions {
    position: absolute;
    bottom: 5px;
    left: auto;
    right: auto;
    text-align: center;

    button {
      padding: 15px;
    }
  }
}
</style>
